import MathText from '../components/VueQuestion/MathText';

// Découpe les <br> ET rend les segments LaTeX $...$ (programme 2025 : les
// descriptions d'attendus embarquent des fractions). Consommé par les
// affichages de libellés savoirs/attendus (compétences, bilans, EvalDetail).
export const renderTextWithLineBreaks = (text) => {
    return text.split("<br>").map((line, index) => (
      <span className="  leading-relaxed" key={index}>
        <MathText>{line}</MathText>
        <br />
      </span>
    ));
  };
